import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { ApiHelper } from './apiHelper';
import { AuthService } from './auth.service';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { filter, map } from 'rxjs/operators';
import { User } from 'anchor-shared/lib/model/entity/user';

@Injectable()
export class RoleGuard implements CanActivate, CanActivateChild {
  subs: Subscription[] = [];
  private isBrowser: boolean = false;

  constructor(
    private router: Router,
    private apiHelper: ApiHelper,
    @Inject(PLATFORM_ID) private platformId: any,
    private authService: AuthService,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      this.subs.push(this.authService.checkSessionPublic().subscribe(() => {}));
    }
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.checkRoles(route);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.checkRoles(route);
  }

  currentUserHasAnyRole(currentUser: User, roles: string[]): boolean {
    return roles.some((requiredRole) =>
      currentUser?.roles.some((userRole) => userRole.type === requiredRole),
    );
  }

  checkRoles(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.authService.currentUser$.pipe(
      filter((currentUser) => currentUser !== undefined),
      map((currentUser) => {
        const requiredRoles: string[] = route.data['roles'] || [];

        if (this.currentUserHasAnyRole(currentUser, requiredRoles)) {
          return true;
        }
        this.router.navigate(['/login'], {
          queryParams: {
            roleError: true,
          },
        });
        return false;
      }),
    );
  }
}
